import React, { Component } from 'react'

export default class About extends Component {
  render() {
    return (
        <>
      <div>This is the about page</div>
        </>
    )
  }
}
